import * as yup from "yup";

export const T3SummarySetupSchema = yup.object().shape({
  valueOfTransmitter: yup.string().required("Transmiter is required!"),
  valueOfContactPerson: yup.string().required("Contact Person is required!"),
});
